<a
  class="powered-by"
  target="_blank"
  [attr.href]="invoice2goUrl"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="logoTapped"
>
  {{ label }}

  <i2g-icon class="invoice2go-logo" [icon]="invoice2goLogoIcon"> </i2g-icon>
</a>
